import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SearchFieldComponent } from '../../components/search-field/search-field.component';

@Component({
  selector: 'app-dashboard',
  imports: [
    SearchFieldComponent,
    TranslatePipe,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {

}
